import type { SVGProps } from "react";
const SenecPictogramInverter = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 13C15 11.3431 16.3431 10 18 10H30C31.6569 10 33 11.3431 33 13V19C33 20.6569 31.6569 22 30 22H18C16.3431 22 15 20.6569 15 19V13ZM18 12C17.4477 12 17 12.4477 17 13V19C17 19.5523 17.4477 20 18 20H30C30.5523 20 31 19.5523 31 19V13C31 12.4477 30.5523 12 30 12H18Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8C10 6.34315 11.3431 5 13 5H35C36.6569 5 38 6.34315 38 8V40C38 41.6569 36.6569 43 35 43H13C11.3431 43 10 41.6569 10 40V38C10 37.4477 10.4477 37 11 37C11.5523 37 12 37.4477 12 38V40C12 40.5523 12.4477 41 13 41H35C35.5523 41 36 40.5523 36 40V27H12V34.2308C12 34.7831 11.5523 35.2308 11 35.2308C10.4477 35.2308 10 34.7831 10 34.2308V8ZM36 8V25H12V8C12 7.44772 12.4477 7 13 7H35C35.5523 7 36 7.44772 36 8Z"
            fill="currentColor"
        />
        <path d="M15 31H23V33H15V31Z" fill="currentColor" />
        <path
            d="M16 37C16.5523 37 17 36.5523 17 36C17 35.4477 16.5523 35 16 35C15.4477 35 15 35.4477 15 36C15 36.5523 15.4477 37 16 37Z"
            fill="currentColor"
        />
        <path
            d="M19 37C19.5523 37 20 36.5523 20 36C20 35.4477 19.5523 35 19 35C18.4477 35 18 35.4477 18 36C18 36.5523 18.4477 37 19 37Z"
            fill="currentColor"
        />
        <path
            d="M23 36C23 36.5523 22.5523 37 22 37C21.4477 37 21 36.5523 21 36C21 35.4477 21.4477 35 22 35C22.5523 35 23 35.4477 23 36Z"
            fill="currentColor"
        />
        <path
            d="M33 31.5269V31H31V31.5269C31 32.2947 30.1671 32.7731 29.5039 32.3862C27.4875 31.21 25 32.7117 25 35H27C27 34.2091 27.8528 33.7385 28.4961 34.1138C30.4927 35.2784 33 33.8383 33 31.5269Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramInverter;
